<template>
  <div
    :class="{
      [$style.formComponent]: true,
      [$style.land]: el.is.land,
      [$style.port]: el.is.port,
      [$style.phone]: el.is.phone
    }"
  >
    <!-- SLIDE HEADING -->
    <h2
      :class="{
        [$style.slideHeadingMarginMedium]: slide.headingMargin === 'medium',
        [$style.slideHeading]: true,
        [$style.slideHeadingNewDesign]: isNewDesign,
        [$style.slideHeadingMarginBig]: slide.headingMargin === 'big'
      }"
      v-if="slide.heading"
      v-html="slide.heading"
    ></h2>

    <!-- FORMS-->
    <div
      :class="{
        [$style.formRow]: isFormsRow,
        [$style.heightSmall]: slide.height === 'small',
        [$style.alignFormWrapperCenter]: slide.align === 'center',
        [$style.alignFormWrapperEnd]: slide.align === 'end',
        [$style.formWrapper]: true,
        [$style.hasGif]: slide.gif
      }"
    >
      <!-- FORM -->
      <form
        :class="{
          [$style.formBox]: true,
          [$style.formMarginBottomBig]: form.marginBottom === 'big',
          [$style.formMarginBottomMedium]: form.marginBottom === 'medium',
          [$style.formMarginTopMedium]: form.marginTop === 'medium',
          [$style.borderBottom]: form.border === 'bottom',
          [$style.alignLeft]: form.align === 'left',
          [$style.alignCenter]: form.align === 'center',
          [$style.isBoxRow]: isBoxRow(form),
          [$style.formBoxFixedHeight]: form.height === 'fixed',
          [$style.noHeadings]:
            !form.heading && !form.heading_2 && !slide.heading,
          [$style.animation]: animationTrigger
        }"
        v-for="form in slide.forms"
        :key="form.formName.name"
      >
        <!-- HIDDEN INPUTS -->
        <template v-for="input in hiddenInputsArray">
          <input
            style="display: none;"
            type="text"
            v-if="input.type === 'honeypot'"
            size="20"
            maxlength="100"
            :key="input.name"
            :id="input.id"
            :name="input.name"
            :value="input.value"
            :wrap="input.wrap"
          />
          <input
            type="hidden"
            v-if="input.type === 'input'"
            :key="input.name"
            :id="input.id"
            :name="input.name"
            :value="input.value"
            :wrap="input.wrap"
          />
          <textarea
            style="display: none;"
            type="hidden"
            v-if="input.type === 'textarea'"
            :key="input.name"
            :id="input.id"
            :name="input.name"
            :wrap="input.wrap"
            :value="input.value"
            v-html="input.value"
          ></textarea>
        </template>

        <!-- FORM IMAGE -->
        <img
          v-if="form.img"
          :src="getImg(form)"
          alt="item image"
          :class="$style.img"
        />
        <!-- FORM HEADING -->
        <h2
          v-if="showForm(form) && (form.heading || form.heading_2)"
          :class="{
            [$style.formHeading]: true,
            [$style.formHeadingNewDesign]: isNewDesign,
            [$style.fixedFormAround]: form.align === 'around',
            [$style.fixedFormHeadingWidth]: form.headingWidth === 'fixed',
            [$style.formHeadingMarginSmall]: form.headingMargin === 'small',
            [$style.formHeadingMarginMedium]: form.headingMargin === 'medium',
            [$style.formHeadingMarginBig]: form.headingMargin === 'big',
            [$style.formHeadingSmall]: form.headingHeight === 'small'
          }"
        >
          <!-- heading text -->
          {{ form.heading }}
          <!-- tooltip -->
          <BaseTooltip
            v-if="showForm(form) && form.tooltip"
            :hoverMode="true"
            :htmlText="form.tooltip"
            :class="$style.tooltip"
            position="absolute"
          >
            <span
              :class="{
                [$style.tooltipIcon]: !isNewDesign,
                [$style.tooltipIconNewDesign]: isNewDesign
              }"
              >?</span
            >
          </BaseTooltip>

          <span
            :class="{
              [$style.formHeading2]: true,
              [$style.formHeading2NewDesign]: isNewDesign,
              [$style.heading2MarginTop]: form.heading2MarginTop === 'small'
            }"
            v-if="form.heading_2"
            >{{ form.heading_2 }}</span
          >
        </h2>

        <!-- INPUTS -->
        <div
          :class="{
            [$style.inputWrapper]: true,
            [$style.inputsCol]: isSlideCol || isFormCol(form),
            [$style.alignRound]: form.align === 'around',
            [$style.inputsSpaceBetween]: isSpaceBetween(form)
          }"
        >
          <!-- INPUT -->
          <template v-for="(input, inputIndex) in form.inputs">
            <!-- 1. radio box -->
            <BaseRadioBox
              :key="inputIndex"
              v-if="input.type === formTypes.RADIO_BOX && showForm(form)"
              :input="input"
              @check="inputHandler"
            />

            <!-- 2. range -->
            <BaseRange
              v-if="input.type === formTypes.RANGE && showForm(form)"
              :key="inputIndex"
              @range="inputHandler"
              :input="input"
            />

            <!-- 3. select -->
            <BaseSelect
              v-if="input.type === formTypes.SELECT && showForm(form)"
              :key="inputIndex"
              :input="input"
              @select="inputHandler"
            />

            <!-- 4. text input -->
            <BaseInput
              v-if="input.type === formTypes.TEXT_INPUT && showForm(form)"
              :key="inputIndex"
              :input="input"
              @onInput="inputHandler"
            />

            <!-- 5. checkbox -->
            <BaseCheckbox
              v-if="input.type === formTypes.CHECKBOX && showForm(form)"
              :key="inputIndex"
              :input="input"
              @onCheck="inputHandler"
            />

            <!-- 6. textarea -->
            <BaseTextarea
              v-if="input.type === formTypes.TEXTAREA && showForm(form)"
              :key="inputIndex"
              :input="input"
              @onTextarea="inputHandler"
            />

            <!-- 7. radio vertical -->
            <BaseRadioVertical
              v-if="input.type === formTypes.RADIO_VERTICAL && showForm(form)"
              :key="inputIndex"
              :input="input"
              @check="inputHandler"
            />

            <!-- 8. radio horizontal -->
            <BaseRadioHorizontal
              v-if="input.type === formTypes.RADIO_HORIZONTAL && showForm(form)"
              :key="inputIndex"
              :input="input"
              @check="inputHandler"
            />
          </template>
        </div>

        <div
          v-if="form.additionalInfo_1 || form.additionalInfo_2"
          :class="$style.additionalInfoBox"
        >
          <p v-if="form.additionalInfo_1" :class="$style.additionalInfo_1">
            {{ form.additionalInfo_1 }}
          </p>
          <p v-if="form.additionalInfo_2" :class="$style.additionalInfo_2">
            {{ form.additionalInfo_2 }}
          </p>
        </div>
        <!-- RADIO TABLE -->
        <RadioTableSlide
          v-if="form.type === formTypes.RADIO_TABLE"
          :form="form"
          @check="inputHandler"
        />

        <!-- OVERVIEW SLIDE -->
        <OverviewSlide
          v-if="form.type === formTypes.CALCULATION"
          :form="form"
        />

        <!-- MULTIPLE CHECKS -->
        <MultiChecksSlide
          v-if="form.type === formTypes.MULTI_CHECKS"
          :form="form"
          @check="inputHandler"
        />

        <!-- RADIO COMBO -->
        <RadioComboSlide
          v-if="form.type === formTypes.RADIO_COMBO"
          :form="form"
          @check="inputHandler"
        />

        <!-- TEXT -->
        <TextSlide
          v-if="form.type === formTypes.TEXT && showForm(form)"
          :form="form"
        />
      </form>
    </div>
    <img
      v-if="slide.gif"
      :src="getGif(slide.gifImg)"
      alt=""
      :class="$style.gif"
    />
  </div>
</template>

<script>
// ui components import
import BaseInput from '@/components/ui/BaseInput.vue'
import BaseCheckbox from '@/components/ui/BaseCheckbox.vue'
import BaseSelect from '@/components/ui/BaseSelect.vue'
import BaseTextarea from '@/components/ui/BaseTextarea.vue'
import BaseRange from '@/components/ui/BaseRange.vue'
import BaseRadioBox from '@/components/ui/BaseRadioBox.vue'
import BaseRadioVertical from '@/components/ui/BaseRadioVertical.vue'
import BaseRadioHorizontal from '@/components/ui/BaseRadioHorizontal.vue'
import BaseTooltip from '@/components/ui/BaseTooltip.vue'

// slide components import
import RadioTableSlide from '@/components/slides/RadioTableSlide.vue'
import OverviewSlide from '@/components/slides/OverviewSlide.vue'
import MultiChecksSlide from '@/components/slides/MultiChecksSlide.vue'
import RadioComboSlide from '@/components/slides/RadioComboSlide.vue'
import TextSlide from '@/components/slides/TextSlide.vue'

import store from '@/store'

export default {
  components: {
    BaseInput,
    BaseTooltip,
    BaseCheckbox,
    BaseSelect,
    BaseTextarea,
    BaseRange,
    BaseRadioBox,
    BaseRadioVertical,
    BaseRadioHorizontal,
    RadioTableSlide,
    OverviewSlide,
    MultiChecksSlide,
    RadioComboSlide,
    TextSlide
  },
  data() {
    return {
      nextText: 'weiter',
      animationTrigger: false,
      timeout: null,
      toShow: false
    }
  },
  computed: {
    // note: new design
    isNewDesign() {
      return store.getters.hausankerDesign
    },
    formTypes() {
      return store.state.formTypes
    },
    el() {
      return store.state.el
    },
    hiddenInputsArray() {
      return store.state.hiddenInputsArray
    },
    hiddenTextareas() {
      return store.getters['hiddenTextareas']
    },
    currentSlide() {
      return store.state.currentSlide
    },
    hausType() {
      return store.state.hausType
    },
    slides() {
      return store.state.slides
    },
    slide() {
      return store.getters['slide']
    },
    isFormsRow() {
      return this.slide.grid === 'row'
    },
    isSlideCol() {
      return this.slide.grid === 'col'
    }
  },
  methods: {
    isFormCol(form) {
      return form.grid === 'col'
    },
    isBoxRow(form) {
      return form.grid === 'row'
    },
    isSpaceBetween(form) {
      return form.grid === 'space-between'
    },
    showForm(form) {
      if (form.showForm === false) {
        this.toShow = false
        return false
      } else {
        this.toShow = true
        return true
      }
    },
    inputHandler(data) {
      // use for scroll to next button in app.vue
      this.$emit('selected')
      store.dispatch('saveData', data)
    },
    getImg(form) {
      if (form.imgV2 && this.isNewDesign) {
        return require('../assets/images/' + form.imgV2)
      } else {
        return require('../assets/images/' + form.img)
      }
    },
    getGif(img) {
      return require('../assets/images/' + img)
    },
    isHalf(input) {
      return input.width === 'half'
    }
  },
  created() {
    this.timeout = setTimeout(() => {
      this.animationTrigger = true
    }, 300)
  },
  watch: {
    toShow(val) {
      this.animationTrigger = false

      this.timeout = setTimeout(() => {
        this.animationTrigger = true
      }, 300)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  }
}
</script>

<style lang="scss" module>
@import '@/scss/variables.scss';

.formComponent {
  position: relative;
}

.slideHeading {
  color: $color_font_3;
  font-size: 28px;
  text-align: center;
  font-weight: 500;
  padding-top: 50px;
  line-height: 1.2;
}

.slideHeadingNewDesign {
  font-family: Arya;
  font-style: normal;
  font-weight: bold;
}

.formWrapper {
  padding-bottom: 80px;
}

.alignFormWrapperCenter {
  display: flex;
  align-items: center;
}

.alignFormWrapperEnd {
  display: flex;
  align-items: flex-end;
}

// computed
.formRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  // padding-left: 50px;
}

.formBox {
  // width: 780px;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0;
}

.animation {
  transition: opacity 0.3s ease-in-out;
  opacity: 1;
}

.formBoxFixedHeight {
  height: 86px;
  justify-content: flex-end;
}

.formMarginBottomBig {
  margin-bottom: 88px;
}

.formMarginBottomMedium {
  margin-bottom: 53px;
}

.formMarginTopMedium {
  margin-top: 53px;
}

.formRow {
  &.formWrapper {
    margin-top: 0px;
  }
}
.formRow .formBox {
  width: 50%;
}
.borderBottom {
  border-bottom: 1px solid #d8d8d8;
  padding-bottom: 45.5px;
  padding-top: 45.5px;
}
.inputWrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.inputsSpaceBetween {
  justify-content: space-between;
}

.alignRound {
  justify-content: space-around;
  width: 100%;
}
.inputsCol {
  flex-direction: column;
}

.full {
  width: 100%;
}

.half {
  width: 48%;
  display: inline-block;
}

.slideHeadingMarginMedium {
  margin: 31px;
}

.tooltip {
  cursor: help;
  display: inline-block;
  position: absolute;
  top: -22px;
  right: -30px;
  height: 33px;
  width: 27px;
}

.tooltipIcon {
  font-size: 17px;
  font-weight: bold;
  color: white;
  background-color: $color_green_1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 7px;
  height: 100%;
}

// note: new design
.tooltipIconNewDesign {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 13px;
  border-radius: 50%;
  height: 27px;
  width: 27px;
  background: $color_bg_light;
  border: 2px solid $color_font_new;
  padding: 1px;
}

.formHeading {
  position: relative;
  text-align: center;
  font-size: 28px;
  color: $color_font_3;
  font-weight: 500;
  margin: 0;
  line-height: 1.2;
}

// note: new design
.formHeadingNewDesign {
  font-family: Arya;
  font-style: normal;
  font-weight: bold;
}

.fixedFormHeadingWidth {
  max-width: 280px;
}

.formHeading2 {
  display: block;
  font-size: 19px;
}

// note: new design
.inputHeading2NewDesign {
  font-family: Arya;
  font-style: normal;
}
.heading2MarginTop {
  margin-top: 20px;
  display: inline-block;
}
.alignLeft {
  align-items: flex-start;
  padding-left: 11.82%;
  .formHeading {
    margin-top: 14px;
    padding-right: 11%;
  }
}

.alignCenter {
  align-items: center;
  .formHeading {
    margin-top: 14px;
  }
}

.formHeadingSmall {
  font-size: 22px;
  margin-bottom: 0;
  text-align: center;
}

.formHeadingMarginSmall {
  margin-bottom: 20px;
}

.formHeadingMarginMedium {
  margin-bottom: 25px;
}

.formHeadingMarginBig {
  margin-bottom: 44px;
}

.fixedFormAround {
  width: 40%;
  font-size: 18px;
  text-align: left;
  margin: 0;
  margin-left: 22px;
}

// .formBox:not(:last-child) {
//   margin-bottom: 40px;
// }

.img {
  width: 70px;
  padding-bottom: 23px;
}

.isBoxRow {
  flex-direction: row;
}

.additionalInfoBox {
  line-height: 1.2;
  margin-top: 20px;
  font-weight: 500;
}
.additionalInfo_1 {
  font-size: 22px;
}
.additionalInfo_2 {
  font-size: 19px;
}

.hasGif {
  margin-bottom: 50px;
}

.gif {
  position: absolute;
  bottom: 16.9px;
  right: -5px;
}

// note: LAND
.land {
  .fixedFormAround {
    width: 50%;
  }
  .formHeading2 {
    font-size: 17px;
  }
}

// note: PORT
.port {
  .slideHeading {
    padding-top: 0;
    margin-bottom: 20px;
  }
  .formWrapper {
    padding-bottom: 0;
  }
  .formMarginBottomBig {
    margin-bottom: 25px;
  }
  .alignLeft {
    width: 100%;
  }
  .isBoxRow {
    flex-direction: column;
  }
  .buttons {
    margin-bottom: 40px;
  }
  .alignFormWrapperCenter {
    margin-top: 10px;
  }
  .isBoxRow {
    flex-direction: row;
  }
  .hasGif {
    margin-bottom: 130px;
  }
  .gif {
    bottom: 0px;
  }
}

// NOTE: PHONE
.phone {
  height: auto;
  padding: 0px;
  &.formComponent {
    .formHeadingMarginBig {
      margin-top: 5px;
      margin-bottom: 20px;
    }
    .formHeadingMarginMedium {
      margin-bottom: 18px;
    }
    .formHeading2 {
      font-size: 16px;
    }
    height: auto;
    .slideHeading {
      padding-top: 0;
      font-size: 22px;
      margin-top: 35px;
    }
    .borderBottom {
      border-bottom: none;
      padding-bottom: 0;
      padding-top: 0;
    }
    .formMarginTopMedium {
      margin-top: 0;
    }
    .img {
      padding-bottom: 0;
      display: inline-block;
      margin-top: -15px;
    }
    .fixedFormAround {
      text-align: center;
      font-weight: bold;
      margin: 0;
      font-size: 18px;
      margin-top: 15px;
    }
    .alignLeft {
      padding-left: 0;
      .formHeading {
        margin-top: 0;
      }
    }
    .alignCenter {
      align-items: flex-start;
      padding-left: 0;
      .formHeading {
        margin-top: 0;
      }
    }
    .alignFormWrapperCenter {
      .img {
        margin-top: 40px;
      }
    }
  }
  .inputWrapper {
    width: 100%;
  }
  .noHeadings {
    margin-top: 35px;
  }
  .formBox {
    height: fit-content;
    width: 100%;
    margin-bottom: 39px;
  }
  .slideHeading {
    margin-top: 20px;
  }
  .formHeading {
    font-size: 22px;
    width: fit-content;
    // margin-top: 25px;
    margin-top: 35px;
  }
  .alignRound {
    margin-top: 20px;
    font-size: 16px;
  }

  .formWrapper {
    height: fit-content;
    padding: 0;
    margin-top: 0px;
    .formMarginBottomBig {
      margin-bottom: 0px;
    }
    .formMarginTopMedium {
      margin-bottom: 20px;
    }
  }

  .formRow {
    flex-direction: column;
    padding-left: 0px;
  }
  .isBoxRow {
    flex-direction: column;
  }
  .isBoxRow:not(:last-child) {
    margin-top: 20px;
  }

  .tooltipText {
    font-size: 14px;
  }

  .inputsSpaceBetween {
    margin-top: 10px;
  }

  .formBoxFixedHeight {
    h2 {
      margin-top: 0px;
    }
    form {
      margin-bottom: 20px;
    }
  }

  .img {
    margin-top: 10px;
  }

  .hasGif {
    margin-bottom: 110px;
  }

  .gif {
    position: absolute;
    bottom: 10px;
    right: 50%;
    transform: translateX(50%);
  }
}
</style>
